import moment from 'moment';
import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
// i18n
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import TaskActions from '../../components/actionButtons/taskActionButtons';
import TaskFilters from '../../components/Lists/TaskFilters';
import TaskList from '../../components/Lists/TaskList';
import { taskfields, task_status, taskStatusBack } from '../../constants/task_fields';
// Import actions redux
import {
  cancelTask,
  getLastTask,
  getSystemStatus,
  getTask,
  getWorkstations,
  getWsPositions,
  queryTaskStatusStart,
  resendTask,
  pauseQueueTask,
  resumeQueueTask,
} from '../../store/actions';
import './datatables.scss';

class Tasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      tasklist: null,
      totalPages: 0,
      alert: null,
      nextid: 0,
      creationDisabled: false,
      showAlert: false,
      showAlertResend: false,
      showAlertQueryStat: false,
      // P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad).
      filters: { status: '', rack: '', workstation: '', position: '', priorityMin: '', priorityMax: '' },
    };
  }

  componentDidMount() {
    this.props.getTask(this.state.user, 100, 1);
    this.props.getLastTask(this.state.user);
    this.props.getWorkstations(this.state.user);
    this.props.getWsPositions(this.state.user);
  }

  componentDidUpdate(prevProps) {
    // ➔ CORREGIDO: Reconstruye la tabla si terminó la carga O si tasklist está en null y tenemos datos
    const hasFinishedLoading = this.props.loadingGetTask === false && prevProps.loadingGetTask === true;
    const needsTableBuild = !this.state.tasklist && this.props.tasks && this.props.tasks.elements;

    if (hasFinishedLoading || needsTableBuild) {
      let tasks = this.props.tasks?.elements;
      this.setState({ totalPages: this.props.tasks?.totalPages || 0 });
      if (tasks) {
        this.prepareData(tasks);
      }
    }

    if (this.props.loadingGetLastTask === false && prevProps.loadingGetLastTask === true) {
      this.setState({ next_id: this.props.lastTask });
    }

    if (this.props.loadingGetWs === false && prevProps.loadingGetWs === true) {
      let ws = this.props.ws;
      if (ws && ws.length === 0) {
        this.setState({ creationDisabled: true });
      }
    }

    if (prevProps.messageQueryStatusTask === null && this.props.messageQueryStatusTask === true) {
      this.refetchTasks();
    }

    if (prevProps.messageResend === null && this.props.messageResend === true) {
      this.refetchTasks();
    }

    // P01021-147 (reporte cliente): estas 4 acciones hacían history.go() (recarga completa del
    // navegador) tras completarse, perdiendo el filtro aplicado (estado de TaskFilters, en
    // memoria). Ahora solo refrescan el listado, conservando this.state.filters.
    if (this.props.loadingReturnTask === false && prevProps.loadingReturnTask === true) {
      this.refetchTasks();
    }

    if (this.props.pendingToreturnTaskLoading === false && prevProps.pendingToreturnTaskLoading === true) {
      this.refetchTasks();
    }

    if (this.props.loadingPauseQueueTask === false && prevProps.loadingPauseQueueTask === true) {
      this.refetchTasks();
      // P01021-147bis: el botón "Pausar/Reanudar tareas" lee this.props.taskStatus, que solo se
      // pedía una vez al montar el layout (Header.js) — con history.go() una recarga completa lo
      // refrescaba de rebote; sin ella, hay que volver a pedirlo explícitamente aquí.
      this.props.getSystemStatus(this.state.user);
    }

    if (this.props.loadingResumeQueueTask === false && prevProps.loadingResumeQueueTask === true) {
      this.refetchTasks();
      this.props.getSystemStatus(this.state.user);
    }
  }

  // P01021-147: refresca solo el listado de tareas, conservando el filtro activo. No limpia
  // this.state.tasklist antes de pedir los datos (se reconstruye en componentDidUpdate cuando
  // llega la respuesta) para no colapsar la tabla a "Cargando..." en cada refresco.
  refetchTasks() {
    const { status, rack, workstation, position, priorityMin, priorityMax } = this.state.filters;
    this.props.getTask(this.state.user, 100, 1, status, rack, workstation, position, priorityMin, priorityMax);
  }

  prepareData(tasks) {
    let columns = taskfields;
    let rows = [];
    tasks
      .filter((task) => task.sgtTaskStatus >= taskStatusBack.PENDIENTE_RETORNO)
      .forEach((task) => {
        task['sgtWS'] = task.sgtTaskStatus >= taskStatusBack.COLA ? '' : task['sgtWS'];
        task['status'] = task_status[task['sgtTaskStatus']];
        // P01021-145: priority es VARCHAR en BD; sin convertir a número, MDBDataTable
        // lo ordena como texto ("49" antes que "5") al pulsar la cabecera "Prioridad".
        task['priority'] = parseInt(task['priority'], 10);
        task['actions'] = <TaskActions task={task} page_origin="/tasks"></TaskActions>;
        task['sgpCreated'] = moment(task['sgpCreated']).format('DD/MM/YYYY hh:mm');
        rows.push(task);
      });
    let data = { columns, rows };
    this.setState({ tasklist: data });
  }

  refresh(event) {
    event.preventDefault();

    // ➔ Limpiamos cualquier error previo guardado en Redux de forma segura
    if (this.props.clearTaskErrors) {
      this.props.clearTaskErrors();
    }

    this.refetchTasks();
  }

  // P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad).
  handleFilterChange(filters) {
    this.setState({ filters }, () => this.refetchTasks());
  }

  newTask(event) {
    event.preventDefault();
    if (this.state.creationDisabled) {
      this.displayAlert();
    } else {
      this.props.history.push({
        pathname: 'newtasks',
        query: { next_id: this.props.lastTask, page_origin: '/tasks' },
      });
    }
  }

  resendTasks() {
    this.setState({ showAlertResend: false });
    this.props.resendTask(this.state.user.token);
  }

  queryTaskStatus() {
    this.setState({ showAlertQueryStat: false });
    this.props.queryTaskStatusStart(this.state.user.token);
  }

  displayAlert() {
    this.setState({ showAlert: true });
  }

  hideAlert() {
    this.setState({ showAlert: false });
  }

  displayAlertResend() {
    this.setState({ showAlertResend: true });
  }

  hideAlertResend() {
    this.setState({ showAlertResend: false });
  }

  displayAlertQueryStat() {
    this.setState({ showAlertQueryStat: true });
  }

  hideAlertQueryStat() {
    this.setState({ showAlertQueryStat: false });
  }

  render() {
    if (!this.state.tasklist) {
      return (
        <React.Fragment>
          <div className="p-4 text-center">{this.props.t('Cargando...')}</div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Button
                  onClick={(event) => this.refresh(event)}
                  color="primary"
                  className="btn btn-primary buttonStatus usersButtons"
                >
                  <i size="lg" className="mdi mdi-refresh"></i>
                </Button>

                {this.state.user.role_id < 3 && (
                  <Button
                    className="btn btn-primary waves-effect waves-light usersButtons"
                    onClick={(event) => this.newTask(event)}
                  >
                    {this.props.t('Crear nueva tarea')}
                  </Button>
                )}

                <Button
                  className="btn btn-primary waves-effect waves-light usersButtons"
                  onClick={(event) => this.displayAlertResend(event)}
                >
                  {this.props.t('Reenviar tareas')}
                </Button>

                <Button
                  className="btn btn-primary waves-effect waves-light usersButtons"
                  onClick={(event) => this.displayAlertQueryStat(event)}
                >
                  {this.props.t('Sincronizar tareas')}
                </Button>

                {this.props.taskStatus ? (
                  <Button
                    className="btn btn-success waves-effect waves-light usersButtons"
                    onClick={(event) => this.props.resumeQueueTask(null, this.state.user.token, this.props.history)}
                  >
                    {this.props.t('Reanudar tareas')}
                  </Button>
                ) : (
                  <Button
                    className="btn btn-primary waves-effect waves-light usersButtons"
                    onClick={(event) => this.props.pauseQueueTask(null, this.state.user.token, this.props.history)}
                  >
                    {this.props.t('Pausar tareas')}
                  </Button>
                )}

                <Card>
                  <CardBody>
                    <TaskFilters
                      ws={this.props.ws}
                      ws_positions={this.props.ws_positions}
                      onFilterChange={(filters) => this.handleFilterChange(filters)}
                    />
                    <TaskList
                      taskslist={this.state.tasklist}
                      totalPages={this.state.totalPages}
                      getTask={this.props.getTask}
                      extraArgs={[
                        this.state.filters.status,
                        this.state.filters.rack,
                        this.state.filters.workstation,
                        this.state.filters.position,
                        this.state.filters.priorityMin,
                        this.state.filters.priorityMax,
                      ]}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        {this.state.alert}
        {this.state.showAlert && (
          <SweetAlert
            title={this.props.t('Para la creación de tareas debe haber el menos una estación de trabajo disponible')}
            warning
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.hideAlert()}
          ></SweetAlert>
        )}

        {this.state.showAlertResend && (
          <SweetAlert
            title={this.props.t('ATENCIÓN') + ':' + this.props.t('¿Está seguro que desea reenviar las tareas?')}
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            cancelBtnText={this.props.t('cancel')}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.resendTasks()}
            onCancel={() => this.hideAlertResend()}
          >
            {this.props.t('¿Continuar con el reenvío?')}
          </SweetAlert>
        )}

        {this.state.showAlertQueryStat && (
          <SweetAlert
            title={this.props.t('ATENCIÓN') + ':' + this.props.t('¿Está seguro que desea sincronizar las tareas?')}
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            cancelBtnText={this.props.t('cancel')}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.queryTaskStatus()}
            onCancel={() => this.hideAlertQueryStat()}
          >
            {this.props.t('¿Continuar con la sincronización?')}
          </SweetAlert>
        )}
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetTask, loadingGetTask, tasks, successTask } = state.GetTasks;
  const { loadingReturnTask } = state.ReturnTask || {};
  const { loadingCancelTask } = state.CancelTask || state.GetTasks || {};
  const { loadingGetLastTask, lastTask } = state.getLastTask || {};
  const { messageQueryStatusTask } = state.queryTaskStatusStart || {};
  const { messageResend } = state.resendTask || {};
  const { errorGetWs, loadingGetWs, ws, successWs } = state.GetWS || {};
  const { taskStatus } = state.GetSystemStatus || {};
  const { ws_positions } = state.getWsPositions || {};
  // P01021-147: para refrescar el listado (conservando el filtro) cuando cualquiera de estas
  // acciones termina, en vez del history.go() (recarga completa) que hacían antes sus sagas.
  const { pendingToreturnTaskLoading } = state.pendingToReturnTask || {};
  const { loadingUpdateTask: loadingPauseQueueTask } = state.pauseQueueTask || {};
  const { loadingUpdateTask: loadingResumeQueueTask } = state.resumeQueueTask || {};

  return {
    errorGetTask,
    loadingGetTask,
    tasks,
    successTask,
    loadingCancelTask,
    loadingReturnTask,
    errorGetWs,
    loadingGetWs,
    ws,
    successWs,
    loadingGetLastTask,
    lastTask,
    messageQueryStatusTask,
    messageResend,
    taskStatus,
    ws_positions,
    pendingToreturnTaskLoading,
    loadingPauseQueueTask,
    loadingResumeQueueTask,
  };
};

// ➔ CORREGIDO: mapDispatchToProps como función compatible con Redux-Saga
const mapDispatchToProps = (dispatch) => ({
  getTask: (user, size, page, status, rack, workstation, position, priorityMin, priorityMax) =>
    dispatch(getTask(user, size, page, status, rack, workstation, position, priorityMin, priorityMax)),
  getLastTask: (user) => dispatch(getLastTask(user)),
  getSystemStatus: (user) => dispatch(getSystemStatus(user)),
  cancelTask: (task, response, token, history) => dispatch(cancelTask(task, response, token, history)),
  getWorkstations: (user) => dispatch(getWorkstations(user)),
  getWsPositions: (user) => dispatch(getWsPositions(user)),
  resendTask: (token) => dispatch(resendTask(token)),
  queryTaskStatusStart: (token) => dispatch(queryTaskStatusStart(token)),
  // P01021-147bis: el action creator es (task, token, history), sin "event" — este wrapper
  // declaraba 4 parámetros y "funcionaba" solo porque el botón de aquí ya lo llamaba con 3
  // argumentos (null, token, history), desplazándolos accidentalmente a los valores correctos.
  // Corregido para que ambos lados coincidan explícitamente, sin depender de esa casualidad.
  pauseQueueTask: (task, token, history) => dispatch(pauseQueueTask(task, token, history)),
  resumeQueueTask: (task, token, history) => dispatch(resumeQueueTask(task, token, history)),
  clearTaskErrors: () => {
    dispatch({ type: 'RETURN_TASK_FAILED', payload: null });
    dispatch({ type: 'CANCEL_TASK_FAILED', payload: null });
  },
});

export default withRouter(connect(mapStateProps, mapDispatchToProps)(withNamespaces()(Tasks)));
